import { ViewportScroller } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, Scroll } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { TranslateModule } from '@ngx-translate/core';

import { filter } from 'rxjs/operators';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { AppComponent } from 'app/app.component';
import { environment } from 'environments/environment';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { PrebootModule } from 'preboot';

import { LayoutModule } from '@core/layout/layout.module';

import { defaultConfig, testConfig } from '@configs/fuse-config';
import { ADConfig } from '@configs/fuse-config/ad-config.model';

import { mobileFilterToggleReducer } from '@state/mobile-search-filter/mobile-search-filter.reducer';
import { radiusOverrideReducer } from '@state/radius-override/radius-override.reducer';
import { routeRandomizationReducer } from '@state/route-randomize/route-randomize.reducer';
import { searchFilterReducer } from '@state/search-filter/search-filter.reducer';
import { searchKeywordReducer } from '@state/search-keyword/search-keyword.reducer';
import { searchLocationReducer } from '@state/search-location/search-location.reducer';

import {
  FuseProgressBarModule,
  FuseSidebarModule,
  FuseThemeOptionsModule,
} from '@shared/@fuse/components';
import { FuseModule } from '@shared/@fuse/fuse.module';
import { FuseSharedModule } from '@shared/@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';

import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    PrebootModule.withConfig({ appRoot: 'app-root' }),
    BrowserAnimationsModule,
    HttpClientModule,
    TransferHttpCacheModule,
    TranslateModule.forRoot(),

    // Fuse modules
    FuseModule.forRoot(setWhiteLabel()),
    FuseProgressBarModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,

    CoreModule,
    LayoutModule,
    SharedModule,
    NgxDaterangepickerMd.forRoot(),
    GoogleTagManagerModule.forRoot({
      id: environment.GOOGLE_TAG_MANAGER_ID,
    }),

    NgxGoogleAnalyticsModule.forRoot(
      environment.GOOGLE_ANALYTICS_TRACKING_CODE
    ),
    NgxGoogleAnalyticsRouterModule,
    StoreModule.forRoot({
      searchFilter: searchFilterReducer,
      searchKeyword: searchKeywordReducer,
      toggleFromMapFilter: mobileFilterToggleReducer,
      searchLocation: searchLocationReducer,
      toggleRouteRandomization: routeRandomizationReducer,
      overrideRadius: radiusOverrideReducer,
    }),
  ],
  bootstrap: [AppComponent],
  providers: [Title],
})
export class AppModule {
  constructor(router: Router, viewportScroller: ViewportScroller) {
    viewportScroller.setOffset([0, 50]);

    router.events
      .pipe(filter(e => e instanceof Scroll))
      .subscribe((e: Scroll) => {
        if (e.anchor) {
          // anchor navigation
          /* setTimeout is the core line to solve the solution */
          setTimeout(() => {
            viewportScroller.scrollToAnchor(e.anchor);
          });
        } else if (e.position) {
          // backward navigation
          viewportScroller.scrollToPosition(e.position);
        } else {
          // forward navigation
          viewportScroller.scrollToPosition([0, 0]);
        }
      });
  }
}

export function setWhiteLabel(): ADConfig {
  if (environment.whiteLabelConfig.id == 'test') {
    return testConfig;
  }

  return defaultConfig;
}
